import { render, staticRenderFns } from "./PiecesJustifEspace.vue?vue&type=template&id=747f1e36&scoped=true&"
import script from "./PiecesJustifEspace.vue?vue&type=script&lang=js&"
export * from "./PiecesJustifEspace.vue?vue&type=script&lang=js&"
import style0 from "./PiecesJustifEspace.vue?vue&type=style&index=0&id=747f1e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747f1e36",
  null
  
)

export default component.exports